import { createAction, createSlice } from "@reduxjs/toolkit";

export const fetchTriggerConfigRequest = createAction("workflowTrigger/fetchTriggerConfigRequest");
export const saveTriggerConfigRequest = createAction("workflowTrigger/saveTriggerConfigRequest");

const initialState = {
  config: null,
  configLoading: false,
  configError: null,
  response: null,
  loading: false,
  error: null
};

const workflowTriggerSlice = createSlice({
  name: "workflowTrigger",
  initialState,
  reducers: {
    fetchTriggerConfigStart(state) {
      state.configLoading = true;
      state.configError = null;
    },
    fetchTriggerConfigSuccess(state, action) {
      state.configLoading = false;
      state.config = action.payload || null;
      state.configError = null;
    },
    fetchTriggerConfigFailure(state, action) {
      state.configLoading = false;
      state.configError = action.payload;
    },
    saveTriggerConfigStart(state) {
      state.loading = true;
      state.error = null;
    },
    saveTriggerConfigSuccess(state, action) {
      state.loading = false;
      state.response = action.payload || null;
      state.error = null;
    },
    saveTriggerConfigFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearWorkflowTriggerState(state) {
      state.config = null;
      state.configLoading = false;
      state.configError = null;
      state.response = null;
      state.loading = false;
      state.error = null;
    }
  }
});

export const {
  fetchTriggerConfigStart,
  fetchTriggerConfigSuccess,
  fetchTriggerConfigFailure,
  saveTriggerConfigStart,
  saveTriggerConfigSuccess,
  saveTriggerConfigFailure,
  clearWorkflowTriggerState
} = workflowTriggerSlice.actions;

export default workflowTriggerSlice.reducer;
